<template>
  <b-col class="mt-4" sm="6" md="6">
    <div class="content-center border stat-card">
      <h4 class="bg-lighter stat-text pt-3 pb-3">{{ title }}</h4>
      <h1 class="mt-4 mb-3 stat-title">
        <b-icon :icon="icon_name"></b-icon>
        <br/>
        {{ number }}
      </h1>
    </div>
  </b-col>
</template>
<script>
export default {
  props: ["title", "number", "icon_name"],
};
</script>

<style>
.stat-text {
  height: 80px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: rgba(255, 255, 255, 0.8);
}

.stat-card {
  background-color: rgba(255, 255, 255, 0.5);
  height: 280px;
}

.stat-title {
  font-size: 350%;
}
</style>
